// For full API documentation, including code examples, visit https://wix.to/94BuAAs
import wixWindow from 'wix-window';
import wixUsers from 'wix-users';

$w.onReady(function () {
	const outOfStockVariantsIds = [];
	let productId;
	let productOptions;
	let size = 'גדול (900מ\"ל)';

	$w('#productPage1').getProduct()
		.then((product) => {
			console.log(product);
			productId = product._id;

			const inStock = product.inStock;
			productOptions = product.productOptions;
			if (product.variants.length === 1 && !inStock) {
				outOfStockVariantsIds.push(product.variants[0]._id);
				$w('#button21').show();
			} else if (product.variants.length > 1) {
				const outOfStockVariants = [];
				Object.keys(product.productOptions).forEach(option => {
					product.productOptions[option].choices.forEach(choice => {
						if (!choice.inStock) {
							outOfStockVariants.push(choice.value);
							outOfStockVariantsIds.push(product.variants.filter(variant => Object.values(variant.choices)[0] === choice.value)[0]._id);
							console.log(outOfStockVariantsIds);
						}
					})
				})
				console.log(outOfStockVariants);
				if (outOfStockVariants.length === 1) {
					$w('#text55').text = `האפשרות ${outOfStockVariants[0]} לא במלאי :(`;
					$w('#text55').show();
					$w('#button21').show();
				} else if (outOfStockVariants.length > 1) {
					$w('#text55').text = 'כמה מהאפשרויות לא במלאי :(';
					$w('#text55').show();
					$w('#button21').show();
				}
			}
			//console.log(Object.keys(productOptions));
			//if (Object.keys(productOptions).includes('הגודל כן קובע') && Object.keys(productOptions).length === 1 && product.variants.length === 3) {
				//$w('#box3').show();
				//$w('#image19').show();
				//$w('#image18').show();
				//$w('#image17').show();
				//$w('#button22').show();
				//$w('#button22').onClick((event) => {
				//$w('#shoppingCartIcon2').addToCart(productId, $w('#input1').value, {
					//"choices": {
					//"הגודל כן קובע": size,
					//}
				//})
					//.then(() => console.log('product added to cart'))
					//.catch((e) => console.log(e));
				//})
			//} else {
				//$w('#box3').hide();
			//}
		})
		.catch(e => console.log(e));

	$w('#button21').onClick((event) => {
		console.log(outOfStockVariantsIds, 'outofstockvariantsids');
		console.log(wixUsers.currentUser);
		wixWindow.openLightbox("BacktostockModal", {
			"productId": productId,
			"variantsIds": outOfStockVariantsIds,
			"userId": wixUsers.currentUser.id,
		});
	});

	$w('#image19').onClick((event) => {
		if (size === "ענק (1400מ\"ל)") {
			size = "";
			$w('#box5').hide();
		} else {
			size = "ענק (1400מ\"ל)";
			$w('#box7').hide();
			$w('#box9').hide();
			$w('#box4').hide();
			$w('#box5').show();
		}
	});

	$w('#image19').onMouseIn((event) => {
		if (size !== "ענק (1400מ\"ל)") {
			$w('#box4').show('fade', {'duration': 200});
		}
	})

	$w('#image19').onMouseOut((event) => {
		if (size !== "ענק (1400מ\"ל)") {
			$w('#box4').hide('fade', {'duration': 200});
		}
	})

	$w('#image18').onClick((event) => {
		if (size === "גדול (900מ\"ל)") {
			size = "";
			$w('#box7').hide();
		} else {
			size = "גדול (900מ\"ל)";
			$w('#box5').hide();
			$w('#box9').hide();
			$w('#box6').hide();
			$w('#box7').show();
		}
	});	

	$w('#image18').onMouseIn((event) => {
		if (size !== "גדול (900מ\"ל)") {
			$w('#box6').show('fade', {'duration': 200});
		}
	})

	$w('#image18').onMouseOut((event) => {
		if (size !== "גדול (900מ\"ל)") {
			$w('#box6').hide('fade', {'duration': 200});
		}
	})

	$w('#image17').onClick((event) => {
		if (size === "קטן (450מ\"ל)") {
			size = "";
			$w('#box9').hide();
		} else {
			size = "קטן (450מ\"ל)";
			$w('#box5').hide();
			$w('#box7').hide();
			$w('#box8').hide();
			$w('#box9').show();
		}
	});

	$w('#image17').onMouseIn((event) => {
		if (size !== "קטן (450מ\"ל)") {
			$w('#box8').show('fade', {'duration': 200});
		}
	})

	$w('#image17').onMouseOut((event) => {
		if (size !== "גדול (900מ\"ל)") {
			$w('#box8').hide('fade', {'duration': 200});
		}
	})
})